import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon as FaIcon } from '@fortawesome/react-fontawesome';
import { animated } from 'react-spring';
import { styled } from 'styled-components';
import { color as colorStyled } from 'styled-system';
import { CATEGORIES, DEFAULT_HEIGHT } from './constants';
import * as brandsIcons from './utils/brands';
import * as duotoneIcons from './utils/duotone';
import { getImportIconName } from './utils/getImportIconName';
import * as lightIcons from './utils/light';
import * as regularIcons from './utils/regular';
import * as solidIcons from './utils/solid';
export const FontAwesomeIcon = ({ animation, animationDelay = '0', animationDuration = '2s', animationIterationCount = 'infinite', color, height = DEFAULT_HEIGHT, iconName, iconType = CATEGORIES.REGULAR, rotation = 0, springStyles, }) => {
    const animatedProps = animation ? { [animation]: true } : null;
    let icon = null;
    switch (iconType) {
        case 'regular':
        case CATEGORIES.REGULAR:
            icon = regularIcons[getImportIconName(iconName)];
            break;
        case 'solid':
        case CATEGORIES.SOLID:
            icon = solidIcons[getImportIconName(iconName)];
            break;
        case 'light':
        case CATEGORIES.LIGHT:
            icon = lightIcons[getImportIconName(iconName)];
            break;
        case 'duotone':
        case CATEGORIES.DUOTONE:
            icon = duotoneIcons[getImportIconName(iconName)];
            break;
        case 'brands':
        case CATEGORIES.BRANDS:
            icon = brandsIcons[getImportIconName(iconName)];
            break;
        default:
            break;
    }
    if (!icon) {
        console.warn('FontAwesome icon not found/imported', `${iconName} --- ${iconType}`);
        return null;
    }
    const IconComponent = (springStyles ? AnimatedStyledFaIcon : StyledFaIcon);
    return (_jsx(IconComponent, Object.assign({ color: color, icon: icon, style: Object.assign({ '--fa-animation-delay': animationDelay, '--fa-animation-duration': animationDuration, '--fa-animation-iteration-count': animationIterationCount, height }, springStyles), transform: `rotate-${rotation}` }, animatedProps)));
};
const StyledFaIcon = styled(FaIcon) `
  ${colorStyled}
`;
const AnimatedStyledFaIcon = styled(animated(FaIcon)) `
  ${colorStyled}
`;
//# sourceMappingURL=FontAwesomeIcon.js.map